import script from "./SurveyFormComplete.vue?vue&type=script&setup=true&lang=ts"
export * from "./SurveyFormComplete.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__